import React from 'react';

import Image from '../../assets/img/team/team-4-1.jpg';

const SingleTeamThree = (props) => {
  const { itemClass, teamImage, authorName, designation } = props;

  return (
    <div className={itemClass ? itemClass : 'ed-team-item'}>
      <div className="ed-team-thumb fix">
        <img src={teamImage ? teamImage : Image} alt="" />
      </div>
      <div className="ed-team-content p-relative">
        <div className="ed-team-author-box">
          <h4 className="ed-team-title">
              {authorName ? authorName : 'Micheal Hammond'}
          </h4>
          <span>{designation ? designation : 'Teacher'}</span>
        </div>
      </div>
    </div>
  );
};
export default SingleTeamThree;
